/**
 * Type of Recovery
 */
export const RECOVERY_PASSWORD_TYPE = "PASSWORD"

export const RECOVERY_MAIL_TYPE = "MAIL"
